import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../contexts/store-provider';
import { IDetailProps } from '../../models/forms/IForm';
import { IFactoryVM } from '../../models/response/IFactoryResponse';
import './factory.css';

const FactoryDetails = (props: IDetailProps) => {
  const { factoryStore } = useStore();
  const { GetFactoryByIdService, factoryDetails } = factoryStore;
  const factoryDetail: IFactoryVM = factoryDetails;

  useEffect(() => {
    if (props.selectedRowId > 0) {
      GetFactoryByIdService(props.selectedRowId);
    }
  }, [props.selectedRowId]);

  return (
    <React.Fragment>
      <div className="px-4  py-3">
        <div className="row g-2 d-flex align-items-center">
          <div className="col-auto pt-1 text-muted">
            <svg
              id="fi_18526385"
              viewBox="0 0 64 64"
              height="32"
              fill="currentColor"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
            >
              <path d="m61.427 19.28c-.348-.166-.764-.114-1.062.132l-12.566 10.341 1.936-8.061c.102-.423-.082-.863-.455-1.089-.372-.225-.848-.185-1.175.103l-10.792 9.427 1.466-8.136c.067-.376-.085-.759-.394-.984s-.719-.255-1.058-.077l-17.522 9.26-3.078-16.53c-.088-.474-.501-.817-.983-.817h-5.984c-.482 0-.895.343-.983.817l-6.76 36.303c-.055.292.024.594.214.822s.472.361.769.361h19.503c.008 0 .014-.005.022-.005h38.475c.552 0 1-.448 1-1v-29.963c0-.387-.223-.739-.573-.904zm-52.015 1.9h6.68l.328 1.76h-7.335l.328-1.76zm5.501-6.332.807 4.332h-5.935l.807-4.332h4.322zm-10.709 34.304 4.508-24.212h8.08l4.508 24.212zm55.796-.005h-36.667l-3.145-16.893 16.258-8.592-1.607 8.922c-.075.418.122.838.491 1.047.37.209.832.163 1.151-.117l10.577-9.239-1.9 7.913c-.101.418.078.853.442 1.081s.834.198 1.166-.076l13.236-10.892v26.845z"></path>
              <path d="m31.032 36.291h-5.226c-.552 0-1 .448-1 1v5.226c0 .552.448 1 1 1h5.226c.552 0 1-.448 1-1v-5.226c0-.552-.448-1-1-1zm-1 5.226h-3.226v-3.226h3.226z"></path>
              <path d="m43.032 36.291h-5.226c-.552 0-1 .448-1 1v5.226c0 .552.448 1 1 1h5.226c.552 0 1-.448 1-1v-5.226c0-.552-.448-1-1-1zm-1 5.226h-3.226v-3.226h3.226z"></path>
              <path d="m49.807 43.516h5.226c.552 0 1-.448 1-1v-5.226c0-.552-.448-1-1-1h-5.226c-.552 0-1 .448-1 1v5.226c0 .552.448 1 1 1zm1-5.226h3.226v3.226h-3.226z"></path>
            </svg>
          </div>
          <div className="col-10">
            <p className="title_sidebar">
              {' '}
              <FormattedMessage id={'factory_name'} />
            </p>
            <h3 className="m-0">{factoryDetail.FactoryName}</h3>
          </div>
        </div>

        <div className="row g-2 mt-4 d-flex align-items-center">
          <div className="col-auto pt-1 text-muted">
            <svg
              id="fi_9314369"
              height="32"
              fill="currentColor"
              viewBox="0 0 64 64"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m40.99805 22.98145a9.00776 9.00776 0 0 0 -8.99805-8.99805c-11.929.47161-11.92471 17.52689.00009 17.99708a9.00859 9.00859 0 0 0 8.99796-8.99903zm-15.9961 0a7.00641 7.00641 0 0 1 6.99805-6.99805c9.26241.32906 9.259 13.66964-.00012 13.99708a7.00661 7.00661 0 0 1 -6.99788-6.99903z"></path>
              <path d="m37.84174 49.42029c5.41217-6.47351 13.13971-17.3122 13.13971-26.43884-1.038-25.1731-36.92112-25.18239-37.96293.00014 0 9.1265 7.72757 19.96519 13.13974 26.4387-4.06433.93036-6.51959 2.76935-6.51959 4.97815 0 3.63867 6.36914 5.60156 12.36133 5.60156s12.36133-1.96289 12.36133-5.60156c0-2.2088-2.45526-4.04779-6.51959-4.97815zm-5.84174-43.42029a17.00109 17.00109 0 0 1 16.98145 16.98145c0 11.41601-13.68555 26.50976-16.98145 29.97855-3.2959-3.46875-16.98145-18.5625-16.98145-29.97851a17.00109 17.00109 0 0 1 16.98145-16.98149zm0 52c-10.21073-.17811-14.91815-4.72084-4.34543-6.82892 1.9913 2.27789 3.43674 3.73328 3.63938 3.93537a.99986.99986 0 0 0 1.4121 0c.20264-.20208 1.64808-1.65747 3.63935-3.93542 10.57281 2.10819 5.86529 6.6508-4.3454 6.82897z"></path>
            </svg>
          </div>
          <div className="col-10">
            <p className="title_sidebar">
              <FormattedMessage id={'address'} />
            </p>
            <h3 className="m-0">
              {factoryDetail.FactoryAddress
                ? factoryDetail.FactoryAddress + ' ,'
                : ''}{' '}
              {factoryDetail.FactoryCity}, {factoryDetail.FactoryCountry}
            </h3>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default observer(FactoryDetails);
